<div class="cf-toast-container" (click)="handleToastClick()">
    <div
        #cfToast
        class="cf-toast {{ classes(toast) }}"
        *ngFor="let toast of toastMessages$ | async"
    >
        <span>
            {{ toast.text }}
        </span>
        <svg
            (click)="remove(toast)"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="#EDF0F2"
            xmlns="http://www.w3.org/2000/svg"
            class="cursor-pointer"
        >
            <path
                d="M6.70711 5.29289C6.31658 4.90237 5.68342 4.90237 5.29289 5.29289C4.90237 5.68342 4.90237 6.31658 5.29289 6.70711L8.58579 10L5.29289 13.2929C4.90237 13.6834 4.90237 14.3166 5.29289 14.7071C5.68342 15.0976 6.31658 15.0976 6.70711 14.7071L10 11.4142L13.2929 14.7071C13.6834 15.0976 14.3166 15.0976 14.7071 14.7071C15.0976 14.3166 15.0976 13.6834 14.7071 13.2929L11.4142 10L14.7071 6.70711C15.0976 6.31658 15.0976 5.68342 14.7071 5.29289C14.3166 4.90237 13.6834 4.90237 13.2929 5.29289L10 8.58579L6.70711 5.29289Z"
                fill="#8C9196"
            ></path>
        </svg>
    </div>
</div>
